import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "referral-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Refer A Friend", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "image" }, "IMAGE", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, "Get a friend to join OPT, and get a free $10 in credits for your next meeting", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", { class: "btn-container btn-start" }, [
      _createElementVNode("button", {
        class: "primary start",
        onClick: $setup.progress
      }, "Start your Personal Invite"),
      _createElementVNode("button", {
        class: "borderless toHome",
        onClick: $setup.previous
      }, "Return to the Dashboard")
    ])
  ]))
}